import React from 'react'
import { Link } from 'react-router-dom'
import Flag from '../common/Flag'

export default function EventList({ events }) {
  return (
    <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-1">
      {events.map((event, index) => {
        const codex = event.link?.codex
        const CardTag = codex ? Link : 'div'
        const cardProps = codex ? { to: `/skijumping/${codex}` } : {}

        return (
        <CardTag
          key={index}
          {...cardProps}
          className="event-card hover:scale-[1.02] transition-transform duration-200"
        >
          <div className="md:flex">
            {/* Image and Event Type */}
            <div className="md:w-1/3 relative">
              <div className="aspect-video md:aspect-square overflow-hidden">
                <img 
                  src={event.hill?.hill_images?.[0]?.hill_thumb480} 
                  alt={event.hill?.name}
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Overlay badges */}
              <div className="absolute top-3 left-3 space-y-2">
                <div className="inline-block px-3 py-1 bg-gray-900/80 text-white text-sm font-semibold rounded backdrop-blur-sm">
                  {event.gender === 'M' && `Men ${event.team === 1 ? '/ TEAM' : ''}`}
                  {event.gender === 'L' && `Ladies ${event.team === 1 ? '/ TEAM' : ''}`}
                  {event.gender === 'ML' && 'Mixed'}
                </div>
                
                {(event.sorts?.includes('SGP') || 
                  event.sorts?.includes('WC') || 
                  event.sorts?.includes('COC') || 
                  event.sorts?.includes('WM') || 
                  event.sorts?.includes('OG')) && (
                  <div className="inline-block px-3 py-1 bg-blue-600/90 text-white text-xs font-semibold rounded backdrop-blur-sm">
                    {event.sorts?.includes('SGP') && 'Grand-Prix'}
                    {event.sorts?.includes('WC') && 'Worldcup'}
                    {event.sorts?.includes('COC') && 'Continental Cup'}
                    {event.sorts?.includes('WM') && 'World Championships'}
                    {event.sorts?.includes('OG') && 'Olympic Games'}
                  </div>
                )}
              </div>
            </div>

            {/* Event Details */}
            <div className="md:w-2/3 p-6">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2">
                    {event.hill?.location?.name}
                    <Flag code={event.hill?.location?.nation?.shortname} className="text-base" />
                  </h3>
                  <p className="text-sm text-gray-600">{event.hill?.name}</p>
                </div>
                
                <span className="ml-4 px-3 py-1 bg-gray-100 text-gray-700 text-sm font-semibold rounded-full whitespace-nowrap">
                  HS {event.hill?.hill_size ? Number(event.hill.hill_size).toFixed(0) : 'N/A'}
                </span>
              </div>
              
              {event.competition_acts && event.competition_acts.length > 0 && (
                <div className="space-y-2">
                  {event.competition_acts.map((act, idx) => (
                    <div key={idx} className="flex items-center space-x-3 text-sm">
                      <span className="inline-flex items-center px-2.5 py-1 bg-blue-100 text-blue-800 font-medium rounded">
                        {act.date} {act.time}
                      </span>
                      <span className="text-gray-700">{act.sort}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </CardTag>
        )
      })}
    </div>
  )
}
